export default "__VITE_ASSET__BQIrcSd1__"